// Slick JS
import 'slick-carousel/slick/slick.min';
  
if( $('html').attr('dir') === 'rtl' || $('body').hasClass('rtl') ) {
  //----------------------- Arabic
  // CORPORATE SLIDER
  $('#corporate-slider').slick({
    dots: true,
    slidesToScroll: 1,
    slidesToShow: 4,
    arrows: true,
    infinite: false,
    useTransform: false,
    useCss: false,
    centerMode: false,
    swipeToSlide: true,
    rtl: true,
    responsive: [{
  
        breakpoint: 1199,
        settings: {
          arrows: true,
          slidesToShow: 3,
          slidesToScroll: 1,
        }
      },
      {
  
        breakpoint: 991,
        settings: {
          arrows: true,
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      },
      {
  
        breakpoint: 768,
        settings: {
          arrows: true,
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      },
      {
  
        breakpoint: 576,
        settings: {
          arrows: true,
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      },
    ]
  });
}

  // CORPORATE SLIDER
  $('#corporate-slider').slick({
    dots: true,
    slidesToScroll: 1,
    slidesToShow: 4,
    arrows: true,
    infinite: false,
    useTransform: false,
    useCss: false,
    centerMode: false,
    swipeToSlide: true, 
    responsive: [{
  
        breakpoint: 1199,
        settings: {
          arrows: true,
          slidesToShow: 3,
          slidesToScroll: 1,
        }
      },
      {
  
        breakpoint: 991,
        settings: {
          arrows: true,
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      },
      {
  
        breakpoint: 768,
        settings: {
          arrows: true,
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      },
      {
  
        breakpoint: 576,
        settings: {
          arrows: true,
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      },
    ]
  });
  